/** In-memory retry identity. No message or key is persisted in browser storage. */
export interface LeadAttempt { body: string; key: string }
export const leadAttempt = (previous: LeadAttempt | null, body: string, makeKey: () => string): LeadAttempt =>
  previous?.body === body ? previous : { body, key: makeKey() };

/** Retry-After permits seconds or an HTTP date. Ignore malformed values. */
export function retryDelayMs(value: string | null, now: number): number {
  if (!value) return 0;
  if (/^\d+$/.test(value.trim())) {
    const seconds = Number(value);
    return Number.isSafeInteger(seconds) ? Math.min(seconds * 1000, 24 * 60 * 60 * 1000) : 0;
  }
  const date = Date.parse(value);
  return Number.isFinite(date) ? Math.max(0, Math.min(date - now, 24 * 60 * 60 * 1000)) : 0;
}
